import { useMutation as useGooglePlaceLookupMutation } from "@faire/web-api--source/endpoints/www/api/user/google-place-lookup/post-hooks";
import { IGooglePlaceLookupRequest } from "@faire/web-api--source/indigofair/data/IGooglePlaceLookupRequest";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { useCallback } from "react";

export const useLookupGooglePlace = () => {
  const { mutate, data, isPending } = useGooglePlaceLookupMutation();

  const lookup = useCallback(
    (
      matchedBusiness: IMatchedBusiness | undefined,
      options?: Parameters<typeof mutate>[1]
    ) => {
      if (matchedBusiness?.type === IMatchedBusiness.Type.GOOGLE_PLACES) {
        mutate(
          [
            IGooglePlaceLookupRequest.build({
              google_place_id: matchedBusiness.id,
            }),
          ],
          options
        );
      }
    },
    [mutate]
  );

  return { lookup, lookupResponse: data, isPending };
};
